/**
 * @function remove
 * @description this removes a cookie
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
var _cookie = /*#__PURE__*/ _interop_require_default(require("cookie"));
var _util = require("./util");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var _default = function(name, opt, res) {
    var options = opt = Object.assign({}, opt || {});
    if (typeof document !== "undefined") {
        opt.expires = new Date(1970, 1, 1, 0, 0, 1);
        document.cookie = _cookie.default.serialize(name, "", options);
    }
    // express and fastify
    if ((0, _util.isResWritable)(res) && res.clearCookie) {
        res.clearCookie(name, options);
        return;
    }
    // hapi
    if ((0, _util.isResWritable)(res) && res.unstate) {
        res.unstate(name);
    }
};
